import { HEADERS_TABLE } from "../../../constants/tableHeaders";

const KEY = "leadsTableConfig";
// columnas nuevas que se agregan una sola vez a la configuración ya guardada
const NEW_COLUMNS_KEY = "leadsTableConfigNewColumns";
const NEW_COLUMNS = ["contact_match"];

/**
 * Funcion para cargar la configuracion de los headers
 * de la tabla de leads guardada en el localstorage
 */
function initTableConfig() {
  const config = JSON.parse(localStorage.getItem(KEY));
  if (!config) return HEADERS_TABLE.map(header => header.value);
  // usuarios con configuración previa: se activan las columnas nuevas una vez
  const added = JSON.parse(localStorage.getItem(NEW_COLUMNS_KEY) || "[]");
  const pending = NEW_COLUMNS.filter(c => !added.includes(c));
  if (!pending.length) return config;
  const updated = [...config, ...pending.filter(c => !config.includes(c))];
  localStorage.setItem(KEY, JSON.stringify(updated));
  localStorage.setItem(NEW_COLUMNS_KEY, JSON.stringify(NEW_COLUMNS));
  return updated;
}

// columnas que solo existen cuando la inmobiliaria tiene la función activa
const CONTACT_GROUPING_COLUMNS = ["contact_match"];

// Coincidencias: solo con contact_grouping 'on'. Si la config no se pudo leer
// (coordinator no tiene acceso al detalle de la inmobiliaria) se muestra.
function isColumnAvailable(header, rootState) {
  if (!CONTACT_GROUPING_COLUMNS.includes(header.value)) return true;
  const group = rootState.realEstateGroup?.realEstateGroup;
  if (group) return group.contact_grouping === "on";
  return localStorage.getItem("user_role") === "coordinator";
}

export default {
  namespaced: true,
  state: {
    // almacena los keys de las columnas de la tabla de leads [name, phone, etc]
    headers: initTableConfig()
  },
  getters: {
    /**Array de las columnas custom de la tabla de leads*/
    customHeadersTable: (state, getters, rootState) => {
      const items =
        rootState.realEstateGroup?.realEstateGroup?.custom_fields || [];
      return items.map(c => ({
        ...c,
        text: c.label,
        value: `custom_fields.${c.key}`
      }));
    },
    /**
     * Funcion para obtener las columnas de la tabla de leads que se van a mostrar
     */
    headersTable: (state, getters, rootState) => {
      const localFields = HEADERS_TABLE.filter(
        header =>
          state.headers.includes(header.value) &&
          isColumnAvailable(header, rootState)
      );
      const customFields = getters.customHeadersTable.filter(header =>
        state.headers.includes(header.value)
      );

      return [...localFields, ...customFields];
    },
    /**Array de todas las opciones de las columnas de la tabla de leads*/
    optionsTable: (state, getters, rootState) => {
      const local = HEADERS_TABLE.filter(header =>
        isColumnAvailable(header, rootState)
      ).map(({ text, value, sticky }) => ({
        text,
        value,
        sticky
      }));
      const custom = getters.customHeadersTable.map(({ text, value }) => ({
        text,
        value,
        sticky: false
      }));

      return [...local, ...custom];
    }
  },
  mutations: {
    SET_HEADERS(state, headers) {
      state.headers = headers;
      localStorage.setItem(KEY, JSON.stringify(headers));
    }
  },
  actions: {
    updateHeaders({ commit }, headers) {
      commit("SET_HEADERS", headers);
    }
  }
};
